import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { AnalysisPendingProvider } from './context/AnalysisPendingContext'
import { HistoryRefreshProvider } from './context/HistoryRefreshContext'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HistoryRefreshProvider>
      <AnalysisPendingProvider>
        <App />
      </AnalysisPendingProvider>
    </HistoryRefreshProvider>
  </React.StrictMode>,
) 